<template>
    <div class="_action sub_page">
        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>

                <span class="icon_wrap"><img src="img/part_icon.png" alt="액션 시민 활동" /></span>
                <router-link :to="{ path: '/board', query: { type: 4 } }">액션 시민 활동</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" :alt="state.stateInfo.name" /></span>
                <a href="javascript:void(0)" style="cursor: default">{{ state.stateInfo.name }}</a>
            </div>
            <div class="sub_con_banner">
                <p>
                    {{ state.stateInfo.name }}
                    <span class="remaining_time" v-if="new Date() < new Date(state.stateInfo.endDate)">
                        {{ CommonUtils.getDDayHour(new Date(state.stateInfo.endDate)) }}
                    </span>
                </p>
                <div class="action_info">
                    <p>
                        <span>활동기간</span>
                        {{ CommonUtils.dateFormat(new Date(state.stateInfo.startDate), ".", false) }} ~
                        {{ CommonUtils.dateFormat(new Date(state.stateInfo.endDate), ".", false) }}
                    </p>
                    <p>
                        <span>등록일</span>
                        {{ CommonUtils.dateFormat(new Date(state.stateInfo.createDate), ".", false) }}
                    </p>
                </div>
            </div>
            <div class="btn_wrap _default right_btn _board_type">
                <div class="search_wrap">
                    <input type="text" placeholder="제목 검색" v-model="state.searchText" @keydown.enter="getList" />
                    <button class="search_btn icon_wrap" @click="getList"><img data-v-63e8d312="" src="@/assets/search_btn.png" alt="" /></button>
                </div>
                <button v-if="state.hasAuth && state.isActive" class="common_btn w_130" style="margin-bottom: 15px" @click="loginConfirm">
                    글쓰기
                </button>
            </div>
            <div class="list_table con_board sub_page_con_view suggestList">
                <ul>
                    <li class="thead_li">
                        <div class="tr_div con_tit">
                            <div class="tb_no">번호</div>
                            <div class="tb_subject">제목</div>
                            <div class="tb_wr_name">조회수</div>
                            <div class="tb_wr_name">작성자</div>
                            <div class="tb_date_hour">작성일</div>
                        </div>
                    </li>
                    <li class="tbody_li" v-for="(item, idx) in state.list" :key="item.idx" v-if="state.list.length > 0">
                        <div class="tr_div con_tit">
                            <div class="tb_no no_768">{{ (state.page - 1) * state.size + (idx + 1) }}</div>
                            <div class="tb_subject">
                                <template v-if="item.isNotice == 1">
                                    <span style="margin-right: 3px">
                                        <img src="img/megaphone-fill.png" alt="notice" />
                                    </span>
                                </template>
                                <template v-if="item.isSecret == 1">
                                    <span style="margin-right: 3px">
                                        <img src="img/lock-filled.png" alt="notice" />
                                    </span>
                                </template>
                                <router-link :to="{ name: 'ActionView', params: { stateIdx: state.stateIdx, id: item.idx } }" class="elips_1">
                                    {{ item.isSecret == 0 ? item.title : "비밀글 입니다." }}
                                </router-link>
                            </div>
                            <template v-if="!state.isMobile">
                                <div class="tb_wr_name">
                                    <span class="mo_th">조회수</span>
                                    {{ CommonUtils.numberFormat(item.viewCnt) }}
                                </div>
                                <div class="tb_wr_name">
                                    <span class="mo_th">작성자</span>
                                    {{ item.isSecret == 0 ? item.writer : "익명" }}
                                </div>
                                <div class="tb_date_hour">
                                    <span class="mo_th">날짜</span>
                                    {{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}
                                </div>
                            </template>
                            <template v-else>
                                <div class="_flex _flex_100 _jc_sb">
                                    <div class="_flex">
                                        <div class="tb_wr_name no_450">
                                            <span class="mo_th">조회수</span>
                                            {{ CommonUtils.numberFormat(item.viewCnt) }}
                                        </div>
                                        <span class="divider no_450">｜</span>
                                        <div class="tb_wr_name">
                                            <span class="mo_th">작성자</span>
                                            {{ item.isSecret == 0 ? item.writer : "익명" }}
                                        </div>
                                    </div>
                                    <div class="tb_date_hour">
                                        <span class="mo_th">날짜</span>
                                        {{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}
                                    </div>
                                </div>
                            </template>
                        </div>
                    </li>
                    <li v-else class="tbody_li no_data">
                        <div class="tr_div">
                            <div class="tb_subject" style="justify-content: center; width: 100%">등록된 게시물이 없습니다.</div>
                        </div>
                    </li>
                </ul>
            </div>

            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        PageBtn,
        userStore,
        useRoute,
        ModalDefault,
        getMessageByCode,
        onBeforeMount,
    } from "@/BaseComponent";

    export default {
        props: {
            stateIdx: Number,
        },
        components: { PageBtn, ModalDefault },
        setup(props: any) {
            const global = globalStore();
            const route = useRoute();
            const user = userStore();
            const state = reactive({
                tab: 0 as number,

                stateIdx: 0 as number,
                stateInfo: {} as types.ResBoardStateVOForApi,

                list: [] as Array<any>,

                searchType: "" as string,
                searchText: "" as string,

                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isMobile: false,
                hasAuth: false,
                isActive: false,
            });

            onBeforeMount(() => {
                hasAuth();
            });

            onMounted(() => {
                hasAuth();
                if (Number(route.query.idx) && !isNaN(Number(route.query.idx))) {
                    state.stateIdx = Number(route.query.idx);
                    getStateDetail();
                    getList();
                }

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => route.query.idx,
                () => {
                    state.stateIdx = Number(route.query.idx);
                    getStateDetail();
                    getList();
                },
            );

            const getStateDetail = async () => {
                const res = await apiService.boardAction.stateDetail(state.stateIdx);
                if (res.returnCode === 0) {
                    state.stateInfo = res.data;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const getList = async () => {
                const param: types.ReqBoardActionList = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    startDate: null,
                    endDate: null,
                    isNotice: 0,
                };
                const res: types.ResBoardActionList = await apiService.boardAction.list(state.stateIdx, param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;

                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                    state.isActive = true;
                } else if (res.returnCode === 11) {
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;

                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.isActive = false;
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    router.replace({ path: "/login", query: { redirect: `/actionWrite/${state.stateIdx}` } });
                }
            };

            const loginConfirm = () => {
                if (!(user && user.accessToken)) {
                    state.isShowModal = true;
                    state.modalTab = 7;
                    state.modalTitle = "안내";
                    state.modalContent = "로그인을 진행해주세요.";
                } else {
                    router.push(`/actionWrite/${state.stateIdx}`);
                }
            };
            const hasAuth = () => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin == true &&
                            user.roles != null &&
                            user.roles.some((item: types.RoleVO) => item.key.indexOf("activity") > -1)) ||
                        user.userInfo.hasAuth)
                )
                    state.hasAuth = true;
            };

            return { state, router, handlePageChange, getList, CommonUtils, loginConfirm, closeModal, callBackModal, hasAuth };
        },
    };
</script>
